import React from "react";
import useDrawerDialog from "../../hooks/useDrawerDialog";
import { PlaybookDetail } from "./PlaybookGalleryPanel";

const PlaybookDetailSlideout = ({ open, playbook, onClose, onViewAll }) => {
  // Handles Escape, the focus trap, initial/restored focus, and `inert` while
  // closed — this drawer stays mounted off-screen, so without inert its controls
  // stayed in the tab order.
  const { containerRef, closeButtonRef } = useDrawerDialog(open, onClose);

  return (
    <>
      <div
        onClick={onClose}
        aria-hidden="true"
        className={`fixed inset-0 bg-black/50 z-[110] transition-opacity duration-300 ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      />

      <div
        ref={containerRef}
        role="dialog"
        aria-modal="true"
        aria-label="Playbook detail"
        className={`fixed inset-0 md:inset-y-0 md:right-0 md:left-auto md:top-0 w-full md:w-[860px] md:max-w-[calc(100vw-60px)] z-[120] bg-white dark:bg-gray-900 shadow-2xl flex flex-col transition-transform duration-300 ease-in-out ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-800 shrink-0 flex items-center justify-between gap-4">
          <div className="min-w-0">
            <h2 className="text-sm uppercase tracking-wider font-semibold text-gray-500 dark:text-gray-400">
              Playbook
            </h2>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-0.5">
              Marketing brief for the selected event.
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {onViewAll && (
              <button
                type="button"
                onClick={onViewAll}
                className="px-3 py-1.5 text-xs font-medium rounded-md bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                View all playbooks
              </button>
            )}
            <button
              ref={closeButtonRef}
              type="button"
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
              aria-label="Close"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <div className="flex-1 min-h-0">
          {playbook ? (
            <PlaybookDetail pb={playbook} />
          ) : (
            <div className="h-full flex items-center justify-center text-sm text-gray-400 dark:text-gray-500 px-6 text-center">
              No playbook found for this event yet.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PlaybookDetailSlideout;
